import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IFigure } from "../models/figures";

@Injectable({
  providedIn: "root",
})
export class UserFigureService {
  public list: IFigure[] = [];

  public baseurl: string = "/user-figure";

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get(this.baseurl)
      .toPromise()
      .then((response: IFigure[]) => {
        this.list = response;
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async create(data: { name: string }) {
    return this._httpClient
      .post(this.baseurl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: { name: string }) {
    return this._httpClient
      .put(this.baseurl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseurl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }
}
